<ng-container *ngIf="form" [formGroup]="form">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Property Name & Description</ion-card-title>
      <div
        *ngIf="!listingComplete.nameCompleted(descriptionForm.value) || !listingComplete.descriptionTextCompleted(descriptionForm.value)"
        class="required-pill ion-float-end"
      >
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked
        *ngIf="listingComplete.nameCompleted(descriptionForm.value) && listingComplete.descriptionTextCompleted(descriptionForm.value)"
      ></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <h4>Name your property.</h4>
        <div class="title-information-wrapper">
          <p>Give your property a fun name and provide a summary of what CurbNTurfers can expect.</p>
        </div>
        <input
          [formControl]="name"
          id="site-name"
          name="site-name"
          type="text"
          class="text-input w-input"
          placeholder="Type your property name here..."
        />
        <p class="fine-print">
          Property names appear in the search results so be sure to make it stand out and intriguing to CurbNTurfers.
          Names have to be between 8 to 32 characters, and no special characters should be used.
        </p>
        <br />
        <h4>Describe your property.</h4>
        <p class="fine-print">
          We don&rsquo;t allow addresses, personal information, or website urls. Descriptions have to be at least 150
          characters long.
        </p>
        <p>Good views? What types of terrain or vegetation? Private? What&rsquo;s nearby?</p>
        <label for="site-description" class="sr-only">Site Description</label>
        <textarea
          [formControl]="description"
          name="site-description"
          id="site-description"
          placeholder="Describe your property and what makes your property unique..."
          class="site-description w-input"
        ></textarea>
        <div class="title-information-wrapper">
          <p class="fine-print">
            You&rsquo;ve written
            <strong>
              <span [class.text-danger]="descriptionLength < 150">{{ descriptionLength }}</span
              >/150
            </strong>
            character minimum.
          </p>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Photos of Property (3 Minimum)</ion-card-title>
      <div *ngIf="!listingComplete.photosCompleted(form.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="listingComplete.photosCompleted(form.value)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-listing-photos [form]="form" [listing]="listing"> </curbnturf-listing-photos>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Terrain</ion-card-title>
      <div *ngIf="!listingComplete.terrainCompleted(landTypesFormValue)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="listingComplete.terrainCompleted(landTypesFormValue)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-listing-terrain [landTypes]="landTypes"> </curbnturf-listing-terrain>

        <div class="divider-line"></div>

        <curbnturf-hazard-input [form]="potentialHazardsForm"></curbnturf-hazard-input>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
